import React from 'react'
import { Moneybag } from '../../../svg/moneybag';
import { Bagplus } from '../../../svg/bag_plus';
import { IcoYape } from '../../../svg/ico_yape';
import { Pig } from '../../../svg/pig';
import TabsCustomLinks from '../../tabsCustomLinks/tabsCustomLinks';

const menu = [
  {
    index: 0,
    hash: '/aportes-y-fondo/tipos-de-aportes/aportes-como-dependientes',
    title: 'Dependientes',
    icon: Moneybag,
  },
  {
    index: 1,
    hash: '/aportes-y-fondo/tipos-de-aportes/aportes-como-independientes',
    title: 'Independientes',
    icon: Bagplus,
  },
  {
    index: 2,
    hash: '/aportes-y-fondo/tipos-de-aportes/independientes-por-yape',
    title: 'Independientes por Yape',
    icon: IcoYape,
  },
  {
    index: 3,
    hash: '/aportes-y-fondo/tipos-de-aportes/aportes-voluntarios',
    title: 'Aportes voluntarios',
    icon: Pig,
  },
]

const TiposDeAportesMenu = ({ props }) => {
  return (
    <TabsCustomLinks
    GTMSection="tipos de aporte"
    GTMTitle="Conoce los tipos de aportes que puedes realizar"
    data={menu}
    active={props.active}
  />
  )
};

export default TiposDeAportesMenu;
